// extracted by mini-css-extract-plugin
module.exports = {"statusBadge":"pendingWalletCreationRequests_statusBadge__1QWXH"};